<template>
  <div class="nav-container m-header">
    <div class="navbar header-div">
      <div class="header-logo" @click="toHome()">
        <div class="logo-img" style="width: 40px;">
        </div>
        <div class="logo-title">公卫辅助及慢病智能分析子系统</div>
      </div>
      <div class="header-menu" id="headerMenu">
        <el-menu
          class="el-menu-demo"
          mode="horizontal"
          background-color="#1890FF"
          text-color="#fff"
          @select="handleSelect"
          :default-active="onRoutes">
          <template v-for="(item, index) in menuList">
            <el-menu-item  :key="index + 'el-submenu'" :index="item.name" :class="{ 'is-active': selectedPath == item.name }">
              {{ item.meta != null ? item.meta.title : ''}}
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </div>
    <router-view v-slot="{ Component }" :key="$route.name">
      <transition name="move" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script>
export default {
  name: "Index.vue",
  data(){
    return {
      menuList: [
        {path: '/bi-dataGroup', name: 'bi-dataGroup', meta:{title: '数据集', topName: '/bi-dataGroup'}},
        {path: '/bi-report', name: 'bi-report', meta:{title: '数据报表', topName: '/bi-report'}}
      ],
      selectedPath: 'bi-dataGroup',
      defaultOpenedArr:['1','2']
    }
  },
  computed: {
    onRoutes() {
      let route = this.$route;
      if(route.meta && !!route.meta.topName){
        this.selectedPath = route.meta.topName;
      }
      let path = route.path.replace("/", "");
      return path;
    },
  },
  methods: {
    //去首页
    toHome(){
      this.$router.push("/bi");
    },
    handleSelect(path) {
      this.selectedPath = path;
      this.$router.push(path)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

.nav-container {padding: 0;box-shadow: 0px 1px 2px #dbdbdb;z-index: 100;min-width: 1200px;font-size: 15px;}

.header-div{height: 58px;min-height: 58px;display: flex;align-items: center;position: relative;padding: 0 5px;background: #1890FF;}
.header-div .header-logo{height: 58px;line-height: 58px;margin-right: 20px;}
.header-div .header-logo .logo-img{float: left;height: 58px;}
.header-div .header-logo .logo-img img{margin-top: 10px;}
.header-div .header-logo .logo-title {display: inline-block;color: #FFF;white-space: nowrap;font-size: 19px;text-align: center;cursor: pointer;font-weight: 500;}
.header-div .header-menu{flex: 1;display: flex;min-width: 500px;height: 100%;overflow-x: auto;line-height: 58px;font-size: 15px;}
.header-div .header-right{float: right;position: relative;height: 58px;line-height: 58px;right: 30px;}
.header-div .header-right .header-single{float: left;text-align: center;position: relative;}
.header-photo{height: 58px;line-height: 58px;margin-left: 30px;}
// 图标字体
.iconWord{ font-size: 17px;line-height: 58px;vertical-align:bottom;}
.omega-button {font-size: 20px;line-height: 58px;background: transparent;color: white;width: 40px;padding-left: 10px;padding-right: 10px;}


.header-div .header-menu .el-menu--horizontal>.el-menu-item{height: 58px;line-height: 58px;}
.m-header {height: 58px !important;}


.header-div .el-menu{background: #1890FF;}
.header-div .el-menu--horizontal .el-menu-item{color: #FFF;margin: 0;padding: 0 16px;font-size: 14px;}
//.header-div .el-menu--horizontal .el-menu-item:hover{background: #3d4251;opacity:0.8;}
.header-div .el-menu--horizontal>.el-submenu .el-submenu__title{color: #fff;margin: 0;padding: 0 16px;height: 58px;line-height: 58px;}
.main-table .header-div.sortableColumn + .caret-wrapper{display: block;}

// 菜单
.el-menu {overflow: hidden;}
.el-menu-item{ margin: 0 !important;}

//li的高度
.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{height: 30px !important;line-height: 30px !important;font-size: 12px;padding: 0 10px !important;}
.el-menu.el-menu--horizontal {border-bottom: none;}
.el-menu-item {padding: 0;margin: 0 20px;font-size: 16px;color: #2a304d;}


// 系统消息
.wk-announcement,
.wk-bell {
  color: #9DA9C2;
  cursor: pointer;
  font-size: 20px;
}

.el-badge {
  margin-right: 20px;
}

.user-container {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  .user-img {
    margin-right: 8px;
  }
  .mark {
    font-size: 15px;
    color: #aaaaaa;
  }
}

.user-container:hover {
  .mark {
    color: #2486e4;
  }
}

.el-menu-item {
  padding: 0;
  margin: 0 20px;
  font-size: 16px;
  font-weight: 500;
  color: #2a304d;
  i {
    color: #5c6075;
  }
}


.el-dropdown-unarrow{
  width: 100px;
}

.head-user-photo{
  height: 30px;
  width: 30px;
  border-radius: 30px;
  margin-right: 8px;
}

.head-user-name{color: #FFF; font-size: 12px;}

.header-select-main {line-height: 29px;float: left;width: 150px;height: 29px;line-height: 29px;}
.header-select-main .vue-treeselect__control {height: 29px !important;}
.header-select-main .vue-treeselect__placeholder {line-height: 29px;}
.header-select-main .vue-treeselect__single-value {line-height: 29px;}

.flex-container {
  float: right; /* 向右浮动 */
  display: flex;
  align-items: center; /* 垂直居中 */
  margin-right: 20px;
}



</style>



// WEBPACK FOOTER //
// src/views/bi/Index.vue